import { render, staticRenderFns } from "./OrganizationAbout.vue?vue&type=template&id=252e389b&scoped=true&"
import script from "./OrganizationAbout.vue?vue&type=script&lang=js&"
export * from "./OrganizationAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e389b",
  null
  
)

export default component.exports